module.exports = __webpack_public_path__ + "images/drone-shooting-3bdbc1aa64057448aaf61c45e5419d1b.svg";